<template>
  <div v-if="datos.length > 0">
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left mt-4 gilmer"
      >VACANTES {{ añoSiguiente }} ANEXO(S)</b-col
    >
    <!--VACANTES ANEXO(S)-->
    <div class="accordion filtros" id="vacantes-sedes" role="tablist">
      <b-card
        no-body
        class="border-bottom"
        v-for="(sede, index) in datos"
        :key="'datos-vacantes-sede-' + index"
      >
        <b-card-header
          class="p-0 bg-white"
          :id="'nombrese-de-vacantes-' + index + '-header'"
          role="tab"
        >
          <b-button
            v-b-toggle="'nombre-sede-vacantes-' + index"
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
          >
            <span class="cx d-flex">
              <strong class="text-morado-claro"
                >SEDE {{ sede.direccion.calle }}</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="flechas float-right h5 ml-auto"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          :id="'nombre-sede-vacantes-' + index"
          accordion="vacantes-sedes-adicionales"
          role="tabpanel"
          visible
        >
          <TablaVacantes
            :niveles="
              sede.niveles && nivelesSinEspecialidad(sede.niveles)
                ? nivelesSinEspecialidad(sede.niveles)
                : []
            "
            :nivelesEspecialidad="
              sede.niveles && nivelesConEspecialidad(sede.niveles)
                ? nivelesConEspecialidad(sede.niveles)
                : {}
            "
          />
          <b-card-body class="card-body p-0 text-dark h6">
            <div
              class="small h6 text-black-50"
              v-if="etapaProceso != 'COMPLEMENTARIO'"
            >
              <p>
                * Vacantes referenciales, corresponden a una estimación basada
                en datos informados por el establecimiento.
              </p>
              <p>
                ** Cantidad de estudiantes que postularon al curso el año
                anterior
              </p>
            </div>
            <div class="small h6 text-black-50" v-else>
              <p>
                * Vacantes disponibles, consideran el reporte de los
                establecimientos y los postulantes ya admitidos.
              </p>
              <p>
                ** Cantidad de estudiantes que postularon al curso el año
                anterior
              </p>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import TablaVacantes from "@/components/ficha/derecha/TablaVacantes";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faAngleDown);
export default {
  components: {
    FontAwesomeIcon,
    TablaVacantes
  },
  props: {
    datos: {
      type: Array,
      requiered: true
    }
  },
  data() {
    return {
      etapaProceso: localStorage.getItem("etapaVitrina") || "NORMAL",
      añoSiguiente: localStorage.getItem("anioSiguiente") || "default value"
    };
  },
  computed: {
    leyendaVacantes() {
      let textoVacante = "";
      if (this.etapaProceso === "COMPLEMENTARIO") {
        textoVacante =
          "* Vacantes disponibles, consideran el reporte de los establecimientos y los postulantes ya admitidos.";
      } else {
        textoVacante =
          "* Estimación basada en el reporte de los establecimientos (puede variar).";
      }
      return textoVacante;
    }
  },
  methods: {
    //separa niveles sin especialidad
    nivelesSinEspecialidad(niveles) {
      return niveles.filter(n => {
        if (n.glosaEspecialidad) {
          return false;
        } else {
          return true;
        }
      });
    },
    //separa niveles por especialidad
    nivelesConEspecialidad(niveles) {
      let diccionario = {};
      let nivelesEspecialidad = niveles.filter(n => {
        if (n.glosaEspecialidad) {
          return true;
        } else {
          return false;
        }
      });
      nivelesEspecialidad.forEach(n => {
        n.glosaEspecialidad in diccionario
          ? diccionario[n.glosaEspecialidad].push(n)
          : (diccionario[n.glosaEspecialidad] = [n]);
      });
      return diccionario;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/derecha/VacantesSedes.vue